// extracted by mini-css-extract-plugin
export default {"root":"style_root__Mxf61","actions":"style_actions__n+SiA","tabs":"style_tabs__V2AX+","comments":"style_comments__H-21p"};